import React, { Component } from 'react'
import { Link } from 'react-router-dom'
//import { Route } from 'react-router-dom'
//import StudentReport from './reports/StudentReport'
import '../styles/GlobalStyle.css'
import CustomFooter from '../login/CustomFooter'
import { db } from '../firebase/Firebase'
//import { getURLSplitArray } from '../Util'
import ColType from '../Types'
import { Layout, Button } from 'antd'
import { getAssessmentDisplayName, getIconFromMainSubject } from '../Util'
const Content = Layout.Content
const moment = require('moment')


class StudentCompletedAssessments extends Component {
    state = {
        subjectFilter: 'all',
    }

    componentDidMount() {
        document.title = 'My Completed Quizzes - Dot It'
        window.scrollTo(0, 0)
    }

    getAssessmentCount = () => {
        if (!(this.props.studentBaseProps &&
            this.props.studentBaseProps.completedAssessments)) {
            return 0;
        }

        if (this.state.subjectFilter === 'all') {
            return this.props.studentBaseProps.completedAssessments.length;
        }
        let count = 0;
        this.props.studentBaseProps.completedAssessments.forEach((assessment) => {
            if (!assessment.quiz.hasOwnProperty('standardCategory')) {
                return;
            }
            if (assessment.quiz.standardCategory === this.state.subjectFilter) {
                count += 1;
            }
        });
        return count;
    }

    render() {
        return (
            <div>
                <Layout className="content layout-header-mt">
                    <Layout className="mt-0">
                        <Content className="mt-0">

                            <div className="sub-menu-width m-lr-auto mt-4 pl-2 pr-2">
                                <div className='font-30 font-bold'>My Completed Quizzes</div>
                                <div className='font-24 mb-3 ellipsis' style={{ maxWidth: '500px' }}>
                                    {this.props.studentBaseProps.user &&
                                        this.props.studentBaseProps.user.hasOwnProperty('firstName') &&
                                        this.props.studentBaseProps.user.firstName &&
                                        this.props.studentBaseProps.user.hasOwnProperty('lastName') &&
                                        this.props.studentBaseProps.user.lastName ?
                                        this.props.studentBaseProps.user.firstName + ' ' + this.props.studentBaseProps.user.lastName
                                        : ''}
                                </div>

                                {this.props.studentBaseProps.completedAssessments &&
                                    this.props.studentBaseProps.completedAssessments.length === 0 ?
                                    <div className='p-4 br-20 text-center' style={{ background: '#b3e9ff' }}>
                                        <img src='/no-assessments.png' alt='no assessments' width={250} />
                                        <div className='font-24'>Completed quizzes will appear here!</div>
                                    </div>
                                    : ''}

                                {this.props.studentBaseProps.inTestingTimeRange &&
                                    this.props.studentBaseProps.serverMoment &&
                                    this.props.studentBaseProps.completedAssessments &&
                                    this.props.studentBaseProps.completedAssessments.length > 0 ?
                                    <div className='flex mb-4'>
                                        <Button className={'lg-btn mr-1' + (this.state.subjectFilter === 'all' ? ' ant-btn-primary' : '')}
                                            onClick={() => this.setState({ subjectFilter: 'all' })}>
                                            All
                                        </Button>
                                        <Button className={'lg-btn mr-1' + (this.state.subjectFilter === 'ELA' ? ' ant-btn-primary' : '')}
                                            onClick={() => this.setState({ subjectFilter: 'ELA' })}>
                                            ELA
                                        </Button>
                                        <Button className={'lg-btn mr-1' + (this.state.subjectFilter === 'Math' ? ' ant-btn-primary' : '')}
                                            onClick={() => this.setState({ subjectFilter: 'Math' })}>
                                            Math
                                        </Button>
                                        <Button className={'lg-btn mr-1' + (this.state.subjectFilter === 'Science' ? ' ant-btn-primary' : '')}
                                            onClick={() => this.setState({ subjectFilter: 'Science' })}>
                                            Science
                                        </Button>
                                        <Button className={'lg-btn mr-1' + (this.state.subjectFilter === 'Social Studies' ? ' ant-btn-primary' : '')}
                                            onClick={() => this.setState({ subjectFilter: 'Social Studies' })}>
                                            Social Studies
                                        </Button>
                                    </div>
                                    : ''}

                                {this.props.studentBaseProps.inTestingTimeRange &&
                                    this.props.studentBaseProps.serverMoment &&
                                    this.props.studentBaseProps.completedAssessments &&
                                    this.props.studentBaseProps.completedAssessments.length > 0 &&
                                    this.getAssessmentCount() === 0 ?
                                    <div className='p-4 br-20 text-center' style={{ background: '#b3e9ff' }}>
                                        <div className='font-24'>You have no quizzes available in the "{this.state.subjectFilter}" subject area at this time.</div>
                                    </div>
                                    : ''}

                                {this.props.studentBaseProps.completedAssessments &&
                                    this.props.studentBaseProps.completedAssessments.length > 0 &&
                                    this.getAssessmentCount() > 0 &&
                                    this.props.studentBaseProps.completedAssessments.map((assessment, index) => {
                                        let mainSubject = ''
                                        let quizDisplayName = getAssessmentDisplayName(assessment.quiz)
                                        if (this.state.subjectFilter !== 'all' && assessment.quiz.hasOwnProperty('standardCategory') &&
                                            assessment.quiz.standardCategory !== this.state.subjectFilter) {
                                            return false
                                        }
                                        try {
                                            mainSubject = assessment.quiz.standardCategory
                                        } catch (e) {
                                            try {
                                                // fallback 2
                                                mainSubject = assessment.quiz.docs[0].metadata.standard.standardCategory
                                            } catch (e) {
                                                // fallback 3
                                                mainSubject = 'Math'
                                            }
                                        }

                                        let colorClass = "#4096ff"
                                        //let colorTextClass = "#08979c"
                                        const isMTSS = false
                                        const tier = 'Tier 2'
                                        if (isMTSS) {
                                            if (tier === "Tier 2") {
                                                colorClass = "#faad14"
                                                //colorTextClass = "#d48806"
                                            } else {
                                                colorClass = "#ff4d4f"
                                                //colorTextClass = "#cf1322"
                                            }
                                        }
                                        if (mainSubject === 'Math') {
                                            // colorClass = "#722ed1"
                                            //colorTextClass = "#531dab"
                                        }
                                        return <Link to={"/student/quiz/" + this.props.studentBaseProps.studentId + "?quiz=" + assessment.id} key={assessment.id}>
                                            <div className={"br-20 mb-3 background-fff overflow-hidden font-black font-16 ant-shadow ant-shadow-more-hover parent-hover relative"}
                                            >
                                                <div className="flex flex-v-center p-3">
                                                    <div className="br-50 flex flex-h-center flex-v-center mr-4" style={{ background: colorClass, minWidth: '80px', width: '80px', height: '80px' }}>
                                                        <img
                                                            src={getIconFromMainSubject(mainSubject, '')}
                                                            alt="icon"
                                                            width={48}
                                                        />
                                                    </div>

                                                    <div>
                                                        <div className="font-24 font-bold mb-1">
                                                            <div className='ellipsis' style={{ maxWidth: '400px' }}>
                                                                {'Teacher: ' + assessment.teacher.firstName + ' ' + assessment.teacher.lastName}
                                                            </div>
                                                        </div>
                                                        <div className="font-20 mr-3">
                                                            <span>
                                                                {quizDisplayName}
                                                            </span>
                                                            <span className='text-muted ml-2 font-16'>
                                                                {assessment.hasOwnProperty('timeStamp') &&
                                                                    assessment.timeStamp &&
                                                                    assessment.timeStamp.hasOwnProperty('seconds') &&
                                                                    assessment.timeStamp.seconds ?
                                                                    moment.utc(assessment.timeStamp.seconds * 1000).format('MM/DD/YYYY') : ''}
                                                            </span>
                                                        </div>

                                                    </div>

                                                    <div className='font-20 font-bold ml-auto'>
                                                        {'View'}
                                                    </div>

                                                </div>

                                            </div>
                                        </Link>
                                    })}
                            </div>
                        </Content>
                    </Layout>
                </Layout>
                <CustomFooter />
            </div>
        )
    }
}

export default StudentCompletedAssessments